import { SCRATCH_TYPE_LABEL, type ScratchBlockType } from '../../../shared/scratch';

/**
 * Type tints. Restrained on purpose: teal carries meaning everywhere else in
 * the app, so only Question (a note to ask someone) borrows it, Hook borrows
 * the gold accent, and the rest are paper and line.
 */
const TINTS: Record<ScratchBlockType, string> = {
  idea: 'bg-elevated border-transparent text-muted',
  hook: 'bg-gold/10 border-gold/40 text-gold-deep',
  structure: 'bg-card border-line text-muted',
  line: 'bg-elevated border-line text-muted',
  question: 'bg-accent/10 border-accent/40 text-accent',
  paste: 'bg-card border-line border-dashed text-faint',
};

const BASE =
  'inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full border ' +
  'font-mono text-[9px] uppercase tracking-[0.12em] font-medium leading-none whitespace-nowrap';

/** The pill itself, with no interaction. Used inside menus and the card. */
export function TypeChip({ type }: { type: ScratchBlockType }) {
  return <span className={`${BASE} ${TINTS[type]}`}>{SCRATCH_TYPE_LABEL[type]}</span>;
}

/** The same pill as a button, with the caret that says it opens a menu. */
export function TypeChipButton({
  type,
  open,
  onClick,
  disabled = false,
}: {
  type: ScratchBlockType;
  open: boolean;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      aria-haspopup="menu"
      aria-expanded={open}
      title="Change the block type"
      className={`${BASE} ${TINTS[type]} hover:border-fg/30 transition-colors duration-150`}
    >
      {SCRATCH_TYPE_LABEL[type]}
      <span aria-hidden className="opacity-60 text-[8px]">
        ▾
      </span>
    </button>
  );
}
